<template>
    <SidebarChild
        :selected-item="value"
        :items="AutomationMenuItems"
        @selected="selectedItem"
        :focusActive="true"
        default-open
    />
</template>
<script>
import AutomationMenuItems from "./AutomationMenuItems";
import { mapGetters, mapState } from "vuex";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";

export default {
    name: "AutomationMenu",
    components: {
        SidebarChild,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    data: () => ({
        AutomationMenuItems: AutomationMenuItems(this),
    }),
    mounted() {
        this.AutomationMenuItems = AutomationMenuItems(this);
    },
    methods: {
        selectedItem({ key }) {
            this.$emit("input", key);
        },
    },
};
</script>
